import { type UseQueryResult, useQuery } from 'react-query';
import {
  DisbursementValidationConfigService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetDisbursementConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Shared_Hosting_Dtos_KeyValueSettings_DisbursementKeyValueSettingsDto | undefined,
  unknown
> => {
  const disbursementConfiguration = useQuery(['getDisbursementConfiguration'], async () => {
    return await handleRequest(
      DisbursementValidationConfigService.getApiAwardSettlementApiAppDisbursementValidationConfigValidationRule()
    );
  });

  return disbursementConfiguration;
};

export default useGetDisbursementConfiguration;
